import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const CityInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Ciudad">
      {getFieldDecorator("city", {
        initialValue: implementerProfile?.city
      })(
        <Input
          disabled={isBusy}
          id="city"
          name="city"
          placeholder="Ciudad"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
